import { useApi } from '../useApi'
// eslint-disable-next-line import/no-unresolved
import { getCmsMasterdataContent } from 'data-api'
import { useCmsContentsCount } from './useCmsContentsCount'
import { name as laggySwrMiddlewareName } from '../../stale-while-revalidate/middlewares/laggy'
import { name as paginationSwrMiddlewareName } from '../../stale-while-revalidate/middlewares/pagination'

export const useCmsContents = ({
	type,
	order,
	limit,
	offset,
	skip,
	fields,
	options: { bhUse, ...options } = {},
	paused,
	whereAnd = [],
	pagination: { page, itemsPerPage, infinite } = {},
	optionsCount,
	pausedCount,
} = {}) => {
	const paginationEnabled = !!(page && itemsPerPage)
	const paginationInfinite = paginationEnabled && infinite

	const apiLimit = limit ?? (paginationEnabled ? itemsPerPage : limit)
	const apiOffset = offset ?? (paginationEnabled ? (page - 1) * itemsPerPage : offset)

	const where = { and: [{ 'metadata.status': '1' }, { contentmetacode: type }, ...whereAnd] } //TODO: where is usually an object, here is expecting an array ⚠️

	const { data, error, isValidating, cancel, cancelled } = useApi({
		method: getCmsMasterdataContent,
		args: {
			fields,
			where,
			order,
			limit: apiLimit,
			offset: apiOffset,
			skip,
		},
		paused: paused ?? !type,
		options: {
			...options,
			pagination: {
				enabled: paginationEnabled,
				page,
				infinite: paginationInfinite,
				key: [getCmsMasterdataContent.key, fields, where, order],
			},
			bhUse: paginationEnabled ? [laggySwrMiddlewareName, paginationSwrMiddlewareName] : bhUse,
		},
	})

	const { count } = useCmsContentsCount({ where, options: optionsCount, paused: pausedCount })

	return {
		contents: data,
		count,
		loading: isValidating,
		error,
		cancel,
		cancelled,
	}
}
